__turbopack_context__.v({
  "body": "QmPW9q_body",
  "icon": "QmPW9q_icon",
  "inner": "QmPW9q_inner",
  "label": "QmPW9q_label",
  "labelWrapper": "QmPW9q_labelWrapper",
  "radio": "QmPW9q_radio",
  "root": "QmPW9q_root",
});
